import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom'; // add useLocation
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import '../styles/assignTest.css';

function AssignTest() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  sessionStorage.removeItem('hasUploaded');
  sessionStorage.removeItem('screeningResults');
  sessionStorage.removeItem('screeningReferrals');
  sessionStorage.removeItem('diagnosticResults');
  sessionStorage.removeItem('diagnosticReferrals');

  return (
    <Box className="assign-test-container">
      <Typography component="h1" variant="h5" className="assign-test-title">
        {t('assignTest.title')} <br />
      </Typography>

      <Button
        data-cy="diagnostic_btn"
        onClick={() =>
          navigate('/testcheck', {
            state: { ...(location.state || {}), from: location.pathname, mode: 'diagnostic' },
          })
        }
        type="button"
        variant="contained"
        className="assign-test-btn"
      >
        {t('assignTest.diagnostic')}
      </Button>

      <Button
        data-cy="screening_btn"
        onClick={() =>
          navigate('/testcheck', {
            state: { ...(location.state || {}), from: location.pathname, mode: 'screening' },
          })
        }
        type="button"
        variant="contained"
        className="assign-test-btn"
      >
        {t('assignTest.screening')}
      </Button>

      <Button
        onClick={() => navigate('/testFlow', { state: { from: location.pathname, step: 'test' } })}
        startIcon={<ArrowBackIcon />}
        variant="text"
        className="assign-test-back-btn"
      >
        {t('common.back')}
      </Button>
    </Box>
  );
}

export default AssignTest;